import React, { useRef, useState } from 'react';
import { motion, useReducedMotion } from 'motion/react';
import { SPRING_SOFT } from '../../lib/motion-presets';

/**
 * <Magnetic> — wraps a button/link/icon and pulls it slightly toward the cursor.
 * Premium micro-interaction for CTAs. Disabled under reduced motion.
 *
 * <Magnetic strength={18}>
 *   <button className="btn btn-primary">Apply</button>
 * </Magnetic>
 */
const Magnetic = ({ strength = 16, radius = 120, className = '', style, children }) => {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  if (reduce) {
    return (
      <div className={className} style={style}>
        {children}
      </div>
    );
  }

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const relX = e.clientX - (rect.left + rect.width / 2);
    const relY = e.clientY - (rect.top + rect.height / 2);
    // Scale the pull by how close the cursor is to the center.
    const dist = Math.hypot(relX, relY);
    const falloff = Math.max(0, 1 - dist / radius);
    setPos({
      x: (relX / (rect.width / 2)) * strength * falloff,
      y: (relY / (rect.height / 2)) * strength * falloff,
    });
  };

  const handleLeave = () => setPos({ x: 0, y: 0 });

  return (
    <motion.div
      ref={ref}
      className={`jmi-magnetic ${className}`}
      style={{ display: 'inline-flex', ...style }}
      animate={{ x: pos.x, y: pos.y }}
      transition={SPRING_SOFT}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
    >
      {children}
    </motion.div>
  );
};

export default Magnetic;
